import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { IStorageManagementPageProps } from '../../../models/pages/storageManagement';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import { Doughnut } from 'react-chartjs-2';
import { Table } from 'reactstrap';
import imgAnn from '../../../static/images/announcement.svg';
import { Redirect } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import * as Actions from '../../../store/actions/storageManagement';
import Loading from '../../../components/loading/loading';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();
const graphCustomOptions = {
    responsive: true,
    legend: {
        display: true,
        labels: {
            boxWidth: 10
        }
    },
    scales: {
        xAxes: [
            {
                display: true,
                gridLines: {
                    display: false
                }
            }
        ],
        yAxes: [
            {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: true,
                }
            }
        ]
    }
};

export class FilesAddedActivities extends React.Component<IStorageManagementPageProps, any> {
    state = {
        goToStorageManagementPage: false,
        termId: -1,
        termName: ""
    };

    divArr : any = [];

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.getFilesAddedActivitiesStatistics();
    }

    getFilesAddedActivitiesStatistics() {
        this.props.dispatch(Actions.FilesAddedActivitiesStatistics(
            'getTermsList',
            'get'
        ));
    
    }

      reactGaEvent = (actionName: string)=>{
             ReactGA.event({
                category: window.location.host,
                    action: actionName,
                    label: actionName, 
                    nonInteraction: true, 
                  }); 
       }
            
        
    public render() {
        let data: any;
        if (this.props.filesAddedActivitiesTermListPage !== null) {
            data = {
                labels: this.props.filesAddedActivitiesTermListPage && this.props.filesAddedActivitiesTermListPage.map((item: any) => item.termName),
                datasets: [
                    {
                        label: T.t('r_goal'),
                        data: this.props.filesAddedActivitiesTermListPage && this.props.filesAddedActivitiesTermListPage.map((item: any) => _common.BytesToSize(item.fileSize).split(' ')[0]),
                        backgroundColor: '#1665d8',
                        hoverBackgroundColor: '#1665d8'
                    }
                ]
            }
        }

        if (this.state.goToStorageManagementPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/storage-management'} />
        }

        if (this.state.termId !== -1) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/files-added-activity?term_id=' + this.state.termId + '&term_name=' + this.state.termName} />
        }

        this.divArr=[];

        const loadingSpaces = 60;
        
        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                    <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h2>{T.t('r_files_added_activities')}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-md-right">

                        <a onMouseDown={() => {
                                this.reactGaEvent('G_STORAGE_MANAGEMENT_BACK_BUTTON_CLICKED');
                                this.setState({ goToStorageManagementPage: true })
                            }} 
                            style={{ fontSize: "12px" }}>
                                {T.t('r_gen_storage_management_back')}
                                <i className="material-icons ml-2 align-middle" style={{ fontSize: "17px" }}>arrow_forward</i>
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="white-box">
                                <div style={{ padding: '10px' }}>
                                    <div className="report-card-container-cs">
                                    {(data.datasets[0].data.length>0) ? (

                                        <Bar
                                            data={data}
                                            height={this.props.height}
                                            options={graphCustomOptions}
                                        />
                                    ):
                                    (
                                        <div className="spinner_bg">
                                        <div className="donut" />
                                        <span className="report_title">{T.t('r_gen_reports_loading')}</span>
                                    </div>
                                    )
                                    }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-12 pr-0">
                           
                                    {this.props.filesAddedActivitiesTermListPage && this.props.filesAddedActivitiesTermListPage.length > 0 && (
                                        this.props.filesAddedActivitiesTermListPage.map((item: any, index: any) => {

                                            this.divArr.push(
                                            <div
                                                className="legend"
                                                key={'legendItem-' + item.termId}
                                            >
                                                <span className="legend_small_text">{item.termName ? item.termName : T.t('r_gen_non_term_courses')}</span>
                                                <span className="legend_text">{_common.BytesToSize(item.fileSize) + " %" + item.percentage} </span>
                                            </div>);    
                                        })
                                    )}
                                     {this.divArr.length>0 &&
                                       (
                                        <div className="chart_section" style={{ margin: '0px' }}>
                                        <div className="chart_legends_wight">
                                           {this.divArr}
                                        </div>
                                        </div>
                                       )}
                                        {!this.props.filesAddedActivitiesTermListPage || this.props.filesAddedActivitiesTermListPage.length<=0 &&
                                       <div className="row spinner_bg" style={{ margin: '0px' }} >
                                        <div className="donut" />
                                        <span className="report_title">{T.t('r_gen_reports_loading')}</span>
                                        </div>
                                        } 
                           
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                            <Loading spinnerId={'getTermsList'}>
                                        <div style={{ backgroundColor: '#eeede9' }}>
                                            <ContentLoader
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                viewBox="0 0 1000 400"
                                                className="course_list_lazy_loader"
                                            >
                                                <rect x="5" y="0" rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="261" y="0" rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="517" y="0" rx="3" ry="3" width="250" height="50" />
                                                <rect x="773" y="0" rx="3" ry="3" width="250" height="50" />
    
                                                <rect x="5" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="261" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="517" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
                                                <rect x="773" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
    
                                                <rect x="5" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="261" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                                                <rect x="517" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
                                                <rect x="773" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
    
                                            </ContentLoader>
                                        </div>
                                    </Loading>
                                <Table
                                    className="table-user-list table-striped table-ellipsis table-mobile mt-4"
                                    striped={true}
                                    hover={true}
                                    borderless={true}
                                >
                    
                                    {this.props.filesAddedActivitiesTermListPage && this.props.filesAddedActivitiesTermListPage.length > 0 && (

                                    <thead>
                                        <tr style={{ backgroundColor: '#eaeaea' }}>
                                            <th scope="col" className="text-left">
                                                {T.t('r_term_name')}
                                            </th>
                                            <th scope="col" className="text-center">
                                                {T.t('r_file_size') + " / " + T.t('r_total_size')}
                                            </th>
                                            <th scope="col" className="text-center">
                                                {T.t('r_occupancy_percentage')}
                                            </th>
                                            <th scope="col" className="text-right">
                                                <div className="col-md-11">
                                                    {T.t('r_storage_progress')}
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>

                                    )}

                                    {this.props.filesAddedActivitiesTermListPage && this.props.filesAddedActivitiesTermListPage.length > 0 ? (
                                        <tbody>
                                            {this.props.filesAddedActivitiesTermListPage.map((item: any, index: any) => {
                                                return (
                                                    <tr
                                                        key={'fileSectionItem-' + item.termId}
                                                        data-title={item.termId}
                                                        style={{ cursor: 'initial' }}
                                                    >
                                                        <td data-label={T.t('r_term_name')} className="text-left">
                                                            {item.termName ? item.termName : T.t('r_gen_non_term_courses')}
                                                        </td>
                                                        <td data-label={T.t('r_file_size')} className="text-left">
                                                            {item.percentage > 60 ?
                                                                <div className="d-flex align-items-center text-center justify-content-center">
                                                                    <span className="tag_danger mr-2">{_common.BytesToSize(item.fileSize) + " / " + _common.BytesToSize(item.totalFileSize)}</span>
                                                                </div>
                                                                : item.percentage > 30 ?
                                                                    <div className="d-flex align-items-center text-center justify-content-center">
                                                                        <span className="tag_primary mr-2">{_common.BytesToSize(item.fileSize) + " / " + _common.BytesToSize(item.totalFileSize)}</span>
                                                                    </div>
                                                                    : item.percentage > 0 ?
                                                                        <div className="d-flex align-items-center text-center justify-content-center">
                                                                            <span className="tag_success mr-2">{_common.BytesToSize(item.fileSize) + " / " + _common.BytesToSize(item.totalFileSize)}</span>
                                                                        </div> : null
                                                            }
                                                        </td>
                                                        <td data-label={T.t('r_occupancy_percentage')} className="text-center">
                                                            <div className="progress_tag">
                                                                {item.percentage > 60 ?
                                                                    <div className="d-flex align-items-center text-center justify-content-center">
                                                                        <div className="progress" style={{ width: '100px', minWidth: '100px' }}>
                                                                            <div className="progress-bar progress_danger" role="progressbar" style={{ width: item.percentage ? item.percentage : '60%' }}></div>
                                                                        </div>
                                                                        <span className="progress_text_danger">{item.percentage + "%"}</span>
                                                                    </div>
                                                                    : item.percentage > 30 ?
                                                                        <div className="d-flex align-items-center text-center justify-content-center">
                                                                            <div className="progress" style={{ width: '100px', minWidth: '100px' }}>
                                                                                <div className="progress-bar progress_primary" role="progressbar" style={{ width: item.percentage ? item.percentage : '30%' }}></div>
                                                                            </div>
                                                                            <span className="progress_text_primary">{item.percentage + "%"}</span>
                                                                        </div>
                                                                        : item.percentage > 0 ?
                                                                            <div className="d-flex align-items-center text-center justify-content-center">
                                                                                <div className="progress" style={{ width: '100px', minWidth: '100px' }}>
                                                                                    <div className="progress-bar progress_success" role="progressbar" style={{ width: item.percentage ? item.percentage : '10%' }}></div>
                                                                                </div>
                                                                                <span className="progress_text_success">{item.percentage + "%"}</span>
                                                                            </div> : null
                                                                }
                                                            </div>
                                                        </td>
                                                        <td data-label={T.t('r_storage_progress')} className="text-right">
                                                            <div className="options d-inline-flex align-items-center">
                                                                <button
                                                                    data-toggle="modal"
                                                                    data-target="#preview-question"
                                                                    className="ml-2 category-tag-square tag-green"
                                                                    onClick={() => {
                                                                        this.reactGaEvent('G_STORAGE_MANAGEMENT_X_ACTIVITY_TAKE_ACTION_CLICKED');  
                                                                        this.setState({ termId: item.termId, termName: item.termName })
                                                                     }}
                                                                >
                                                                    {T.t('r_take_action')}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    ) : (
                                       <></>
                                    )}
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IStorageManagementPageProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IStorageManagementPageProps = Object.assign({}, ownProps, {
        filesAddedActivitiesTermListPage: state.storageManagement.filesAddedActivitiesTermListPage,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.storageManagement.filesAddedActivitiesTermListPage === prev.storageManagement.filesAddedActivitiesTermListPage;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CFilesAddedActivities = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(FilesAddedActivities);

export default CFilesAddedActivities;

